import React, { useContext, useRef, useState } from "react";
import { common } from "utils/constant";
import GeneralChat from "components/chats/GeneralChat";
import GroupChat from "components/chats/GroupChat";
import PrivateChat from "components/chats/PrivateChat";
import { MdKeyboardArrowDown } from "react-icons/md";
import Dropdown from "react-bootstrap/Dropdown";
import { CommonContext } from "hooks/CommonContext";
import { ConditionContext } from "hooks/ConditionContext";
import { injectDrawerStyles } from "./drawerStyles";

injectDrawerStyles();

const ChatSection = () => {
  const {
    setParticipateIdToMessage,
    participantOfMeeting,
    userOwnData,
    isComeNewMessage,
    setIsComeNewMessage,
  } = useContext(CommonContext);
  const { interViewTypeToChatSetter, interViewTypeToChat } =
    useContext(ConditionContext);
  const [selectedName, setSelectedName] = useState("");
  const countJoin = useRef(0);

  return (
    <>
      {/* ── Tab navigation ── */}
      {userOwnData.isCandidate ? (
        <div className="dw-header">
          <span className="dw-title">Chat</span>
        </div>
      ) : (
        <div className="dw-chat-nav">
          {/* General */}
          <button
            className={`dw-chat-tab${interViewTypeToChat === common.general ? " dw-tab-active" : ""}`}
            onClick={() => {
              interViewTypeToChatSetter(common.general);
              if (isComeNewMessage === common.general) setIsComeNewMessage("");
            }}
          >
            General
            {isComeNewMessage === common.general && <span className="dw-new-dot" />}
          </button>

          {/* Interviewers */}
          <button
            className={`dw-chat-tab${interViewTypeToChat === common.group ? " dw-tab-active" : ""}`}
            onClick={() => {
              interViewTypeToChatSetter(common.group);
              if (isComeNewMessage === common.group) setIsComeNewMessage("");
            }}
          >
            Interviewers
            {isComeNewMessage === common.group && <span className="dw-new-dot" />}
          </button>

          {/* Individual dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle as="span" className="no-caret">
              <button
                className={`dw-chat-dropdown${interViewTypeToChat === common.individual ? " dw-tab-active" : ""}`}
                onClick={() => {
                  if (isComeNewMessage === common.individual) setIsComeNewMessage("");
                }}
              >
                {selectedName.length > 0 ? selectedName : "Individual"}
                <MdKeyboardArrowDown style={{ fontSize: "18px" }} />
                {isComeNewMessage === common.individual && <span className="dw-new-dot" />}
              </button>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dw-dropdown-menu">
              {(() => {
                countJoin.current = 0;
                return participantOfMeeting.map((user) => {
                  if (user.isJoin && !user.isCandidate) {
                    countJoin.current++;
                    return (
                      <Dropdown.Item
                        key={user.userId}
                        onClick={() => {
                          setParticipateIdToMessage(user.userId);
                          interViewTypeToChatSetter(common.individual);
                          setSelectedName(user.fname + " " + user.lname);
                        }}
                      >
                        {user.fname} {user.lname}
                      </Dropdown.Item>
                    );
                  }
                  return null;
                });
              })()}
              {countJoin.current === 0 && (
                <span className="dw-no-participants">No participants found</span>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}

      {/* ── Chat content ── */}
      <div className="messages-chat-container" style={{ flex: "1 1 auto", minHeight: 0, overflow: "hidden" }}>
        {interViewTypeToChat === common.general    && <GeneralChat />}
        {interViewTypeToChat === common.group      && <GroupChat />}
        {interViewTypeToChat === common.individual && <PrivateChat />}
      </div>
    </>
  );
};

export default ChatSection;